import { authflow, clearTokens, isTokenExpired } from '../utils/authflow';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Redirect from '../components/Theme/Redirect';

const HomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isTokenExpired()) {
      clearTokens();
      authflow.initAuthorizationHandler();
      authflow.fetchServiceConfiguration().then(res => {
        authflow.makeAuthorizationRequest(res);
      });
    } else {
      navigate('/landingpage');
    }
  }, []);

  return <Redirect />
};
export default HomePage;
